'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function SidebarService($q) {
	'ngInject';

	var service = {
		setCurrentUserRoles: setCurrentUserRoles,
		getCurrentUserRoles: getCurrentUserRoles

	};

	var deferred = $q.defer();

	return service;

	function setCurrentUserRoles(currentUserRoles) {
		deferred.resolve(currentUserRoles);
	}

	function getCurrentUserRoles() {
		return deferred.promise;
	}
}

exports['default'] = SidebarService;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/sidebar/sidebar.service.js
 **/